import axios from "../../../axios";
import { getUserAccessToken } from "../user";
  
export const sendMail = async (payload) => {
    try {
        let token = await getUserAccessToken();
        let headers = {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Frame-Options": "sameorigin",
            "strict-transport-security": "max-age=31536000; includeSubDomains",
            "X-XSS-Protection": "1; mode=block",
            "x-content-type-options": "nosniff",
            "X-Download-Options": "noopen",
            "Content-Security-Policy": "policy",
          },
        };
        let obj = await axios.post(
          `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/tf_payments/send_mail`,payload,
          headers
        );
        return obj;
    } catch (e) {
        console.log("error while getting workers", e)
    }
};
